export function initCarousel() {
  document.querySelectorAll("[data-carousel]").forEach((carousel) => {
    const slides = carousel.querySelectorAll(".slide");
    let current = 0;

    const showSlide = (index) => {
      slides.forEach((slide, i) => {
        slide.classList.toggle("opacity-100", i === index);
        slide.classList.toggle("opacity-0", i !== index);
      });
    };

    // ✅ FIX: use carousel instead of section
    const nextBtn = carousel.querySelector(".nextBtn");
    const prevBtn = carousel.querySelector(".prevBtn");

    if (nextBtn && prevBtn) {
      nextBtn.addEventListener("click", () => {
        current = (current + 1) % slides.length;
        showSlide(current);
      });

      prevBtn.addEventListener("click", () => {
        current = (current - 1 + slides.length) % slides.length;
        showSlide(current);
      });
    }

    setInterval(() => {
      current = (current + 1) % slides.length;
      showSlide(current);
    }, 5000);
  });
}